import { Component, Inject, Prop, PropSync, Vue, Watch } from 'vue-property-decorator';
import DsModal from '@/shared/modal/ds-modal.vue';
import { Account, Channel } from '@/shared/model/scrap-agent.model';
import ScrapAgentService from '@/service/scrap-agent.service';

@Component({
  components: { DsModal },
})
export default class ModalStep2LoginComponent extends Vue {
  @Prop({ type: Boolean, required: true }) open!: boolean;
  @Prop({ type: String, required: false }) accountNameSettingModalLogin!: string;
  @Prop({ type: String, required: false }) accountNameUpdateModalLogin!: string;
  @PropSync('channelConnect', { type: Object }) syncedChannelConnect!: any;

  @Inject('scrapAgentService')
  public scrapAgentService!: () => ScrapAgentService;

  // Data properties
  showModal = this.open;
  validatorError: string | null = null;
  login = {
    username: 'Username',
    placeholderUsername: 'Input username',
    password: 'Password',
    placeholderPassword: 'Input password',
  } as any;
  formData = {
    accountId: null,
    accountName: '',
    password: '',
    avatar: null,
  } as any;
  imageUrl = '';
  showPassword = false;
  invalid = true;
  invalidAccount = false;
  invalidText = 'scrap-agent.login-common.invalid-username';
  nameModal = '';

  @Watch('open')
  onOpenChange(value: boolean) {
    this.showModal = value;
    this.showPassword = false;
    if (this.accountNameSettingModalLogin && this.accountNameSettingModalLogin.trim() !== '') {
      this.formData = {
        accountId: null,
        accountName: this.accountNameSettingModalLogin,
        password: '',
        avatar: null,
      } as any;
    } else if (this.accountNameUpdateModalLogin && this.accountNameUpdateModalLogin.trim() !== '') {
      this.formData = {
        accountId: null,
        accountName: this.accountNameUpdateModalLogin,
        password: '',
        avatar: null,
      } as any;
    } else {
      this.formData = {
        accountId: null,
        accountName: '',
        password: '',
        avatar: null,
      } as any;
    }
    this.onChannelTypeChange(this.syncedChannelConnect.channelType);
    this.login.password = 'scrap-agent.login-common.password';
    this.login.username = 'scrap-agent.login-common.username';
    this.login.placeholderPassword = 'scrap-agent.login-common.password-pl';
    this.login.placeholderUsername = 'scrap-agent.login-common.username-pl';
    switch (this.syncedChannelConnect?.channelType) {
      case 'YAHOO':
        this.nameModal = 'Yahoo';
        this.login.password = 'scrap-agent.login-common.password-app';
        this.login.placeholderPassword = 'scrap-agent.login-common.password-app-pl';
        break;
      case 'BRUNCH':
        this.nameModal = 'Brunch';
        break;
      case 'NAVER_BLOG':
        this.nameModal = 'Naver Blog';
        break;
      case 'DAUM':
        this.nameModal = 'Daum';
        this.invalidText = 'scrap-agent.login-common.invalid-mail';
        this.login.username = 'scrap-agent.login-common.mail';
        this.login.placeholderUsername = 'scrap-agent.login-common.mail-pl';
        this.login.password = 'scrap-agent.login-common.password-app';
        this.login.placeholderPassword = 'scrap-agent.login-common.password-app-pl';
        break;
      case 'NAVER':
        this.nameModal = 'Naver';
        this.invalidText = 'scrap-agent.login-common.invalid-mail';
        this.login.username = 'scrap-agent.login-common.mail';
        this.login.placeholderUsername = 'scrap-agent.login-common.mail-pl';
        break;
      case 'NAVER_MAIL':
        this.nameModal = 'Naver Mail';
        this.invalidText = 'scrap-agent.login-common.invalid-mail';
        this.login.username = 'scrap-agent.login-common.mail';
        this.login.placeholderUsername = 'scrap-agent.login-common.mail-pl';
        break;
      default:
        this.nameModal = this.syncedChannelConnect?.channelType;
        this.invalidText = 'scrap-agent.login-common.invalid-username';
        this.login.password = 'scrap-agent.login-common.password';
        this.login.username = 'scrap-agent.login-common.username';
        this.login.placeholderPassword = 'scrap-agent.login-common.password-pl';
        this.login.placeholderUsername = 'scrap-agent.login-common.username-pl';
        break;
    }
  }

  togglePassword() {
    console.log('Before:', this.showPassword);
    this.showPassword = !this.showPassword;
    console.log('After:', this.showPassword);
  }
  @Watch('formData', { deep: true })
  isNext(value: any) {
    if (!value.accountName || !value.password || value.accountName.trim() === '' || value.password.trim() === '') {
      this.invalid = true;
    } else {
      this.invalid = false;
    }

    let regex = null;

    if (this.syncedChannelConnect?.channelType === 'NAVER' || this.syncedChannelConnect?.channelType === 'NAVER_MAIL') {
      regex = /^[a-zA-Z0-9._%+-]+@naver\.com$/;
      if (!value.accountName || value.accountName.trim() === '') {
        this.invalidAccount = false;
      } else if (value.accountName && value.accountName.trim() !== '' && !regex.test(value.accountName)) {
        this.invalid = true;
        this.invalidAccount = true;
      } else {
        this.invalidAccount = false;
      }
    }
  }

  onChannelTypeChange(newType: string) {
    const imageMap: Record<string, string> = {
      NAVER_BLOG: 'https://dzh91b51qfr7r.cloudfront.net/social-channel-thumb/naverblog.png',
      BRUNCH: 'https://dzh91b51qfr7r.cloudfront.net/social-channel-thumb/brunch.png',
      YAHOO: 'https://dzh91b51qfr7r.cloudfront.net/social-channel-thumb/yahoo.png',
      NAVER: 'https://dzh91b51qfr7r.cloudfront.net/social-channel-thumb/navermail.png',
      NAVER_MAIL: 'https://dzh91b51qfr7r.cloudfront.net/social-channel-thumb/navermail.png', // added mapping for NAVER_MAIL
      DAUM: 'https://dzh91b51qfr7r.cloudfront.net/social-channel-thumb/daummail.png', // optional: add a Daum image URL
    };
    this.imageUrl = imageMap[newType] || '';
    this.formData.avatar = imageMap[newType] || '';
  }

  handleCloseModal() {
    if (this.accountNameSettingModalLogin && this.accountNameSettingModalLogin.trim() !== '') {
      this.$emit('modal:backHome');
    } else {
      this.$emit('modal:close');
    }
    this.showModal = false;
  }

  async handleShowAccountList() {
    if (this.syncedChannelConnect.channelType == 'NAVER_BLOG') {
      await this.naverBlogCheckValid();
    } else if (this.syncedChannelConnect.channelType == 'YAHOO') {
      await this.yahooLoginCheckValid();
    } else if (this.syncedChannelConnect.channelType === 'NAVER') {
      await this.naverMailLoginAccount();
    } else if (this.syncedChannelConnect.channelType === 'DAUM') {
      await this.daumLoginAccount();
    }

    this.$emit('modal:openShowAccount', this.syncedChannelConnect, this.formData);
    this.formData = {
      accountId: null,
      accountName: '',
      password: '',
      avatar: null,
    } as any;
  }

  async naverBlogCheckValid() {
    const naverIdRegex = /^[a-z][a-z0-9_]{4,19}$/;
    const naverEmailRegex = /^[a-zA-Z0-9._%+-]+@naver\.com$/;

    // if (!naverIdRegex.test(this.formData.accountName) && !naverEmailRegex.test(this.formData.accountName)) {
    //   this.validatorError = 'Invalid Naver Account. Use a valid Naver ID or an @naver.com email.';
    //   console.log(this.validatorError);
    //   return;
    // } else {
    //   this.validatorError = '';
    // }
  }
  async yahooLoginCheckValid() {}

  async naverMailLoginAccount() {
    // this.validatorError = null;
    // Ensure both accountName and password are provided
    // if (!this.formData.accountName.trim() || !this.formData.password.trim()) {
    //   this.validatorError = 'ID/Email and Password are required.';
    //   this.invalid = ;
    //   return;
    // }
    //
    // const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    // const errorMsg = 'Invalid Naver email address.';
    // if (!emailRegex.test(this.formData.accountName)) {
    //   this.validatorError = errorMsg;
    //   return;
    // }
  }

  async daumLoginAccount() {
    this.validatorError = null;
    // Ensure both accountName and password are provided
    // if (!this.formData.accountName.trim() || !this.formData.password.trim()) {
    //   this.validatorError = 'ID/Email and Password are required.';
    //   return;
    // }
    //
    // const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    // const errorMsg = 'Invalid Daum email address.';
    // if (!emailRegex.test(this.formData.accountName) || !this.formData.accountName.endsWith('@daum.net')) {
    //   this.validatorError = errorMsg;
    //   return;
    // }
    // if (!this.syncedChannelConnect.accounts) {
    //   this.syncedChannelConnect.accounts = [];
    // }
    // this.syncedChannelConnect.accounts.unshift(this.formData);
    // this.$emit('modal:openShowAccount', this.syncedChannelConnect, this.formData);
  }

  async loginAccount() {
    const payload: Account = {
      accountName: this.formData.accountName,
      password: this.formData.password,
      avatar: this.imageUrl,
      chanelName: this.syncedChannelConnect.channelType,
      userKey: JSON.parse(localStorage.getItem('localStorageUser') || '{}')?.id || null,
    };

    console.log(payload, 'payload');
    const result = await this.scrapAgentService().addUserAccount(payload);
    console.log(result.data.body.body, 'payload result');

    this.syncedChannelConnect.accounts ||= [];
    this.formData = { accountId: null, accountName: '', password: '' };
    this.$emit('openShowAccount');
  }
}
